import { Component, HostListener } from '@angular/core';
import { CommonService } from 'src/app/shared/common.service';
import { ToastService } from 'src/app/shared/toast.service';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent {

  blogs: any[] = [];

  page = 1;
  limit = 6; // ✅ set to match your static feel (6 cards initially)
  totalPages = 1;

  loadingBlogs = false;
  loadingMore = false;
  hasMore = false;

  showBlogPopup = false;
  loadingBlogDetail = false;

  selectedBlog: any = null;
  selectedBlogDetail: any = null;

  constructor(
    private commonService: CommonService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.loadBlogs(true);
  }

  // ✅ load first page or subsequent pages
  loadBlogs(reset: boolean = false) {
    if (reset) {
      this.page = 1;
      this.blogs = [];
      this.loadingBlogs = true;
    } else {
      this.loadingMore = true;
    }

    this.commonService.getBlogs(this.page, this.limit).subscribe({
      next: (res: any) => {
        if (res?.status === 1) {
          const newItems = res.data || [];
          const pagination = res.pagination || {};

          this.totalPages = pagination.totalPages || 1;

          // append
          this.blogs = [...this.blogs, ...newItems];

          // ✅ has more?
          this.hasMore = this.page < this.totalPages;
        } else {
          this.toast.showError(res?.message || 'Failed to load blogs');
        }

        this.loadingBlogs = false;
        this.loadingMore = false;
      },
      error: () => {
        this.loadingBlogs = false;
        this.loadingMore = false;
        this.toast.showError('Failed to load blogs');
      }
    });
  }

  loadMore() {
    if (!this.hasMore || this.loadingMore) return;
    this.page += 1;
    this.loadBlogs(false);
  }

  openBlog(blog: any) {
    if (!blog?._id) return;

    this.selectedBlog = blog;
    this.selectedBlogDetail = null;

    this.showBlogPopup = true;
    document.body.style.overflow = 'hidden';

    this.loadingBlogDetail = true;
    this.commonService.getBlogById(blog._id).subscribe({
      next: (res: any) => {
        if (res?.status === 1) {
          this.selectedBlogDetail = res.data;
        } else {
          this.toast.showError(res?.message || 'Failed to load blog details');
          this.closeBlogPopup();
        }
        this.loadingBlogDetail = false;
      },
      error: (err: any) => {
        this.loadingBlogDetail = false;
        this.toast.showError(err?.error?.message || 'Failed to load blog details');
        this.closeBlogPopup();
      }
    });
  }

  closeBlogPopup() {
    this.showBlogPopup = false;
    this.selectedBlog = null;
    this.selectedBlogDetail = null;
    this.loadingBlogDetail = false;
    document.body.style.overflow = '';
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    if (this.showBlogPopup) this.closeBlogPopup();
  }

  getExcerpt(text: string, maxLen: number = 120): string {
    if (!text) return '';
    const t = text.replace(/\s+/g, ' ').trim();
    return t.length > maxLen ? t.slice(0, maxLen) + '...' : t;
  }

  onImgError(event: any) {
    event.target.src = 'assets/placeholder.png';
  }


  
}
